/**
 * Created by lihanying on 2017/7/6.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import {
  GETCLUBTABLELIST,
  GETCLUBTABLEDETAIL,
  GETCLUBSETTLEMENT,
  GETCLUBBILLRECORD,
} from './constants'
import { CLUB_ID } from '../ClubBusiness/constants'

export const getClubTableList = (payload) => {
  return {
    type: GETCLUBTABLELIST,
    payload,
  }
}
export const getClubTableDetail = (payload) => {
  return {
    type: GETCLUBTABLEDETAIL,
    payload,
  }
}

export const getClubSettlement = (payload) => {
  return {
    type: GETCLUBSETTLEMENT,
    payload,
  }
}
export const getClubBillRecordDetail = (payload) => {
  return {
    type: GETCLUBBILLRECORD,
    payload,
  }
}

//桌台列表
export function fetchClubTable() {
  return (dispatch, getState) => {
    const club = sessionStorage.getItem(CLUB_ID)
    const endpoint = `${API_DOMAIN}/BossApi/TableStatus/club_id/${club}`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubTableList(data))
      return data
    })
  }
}

//详情
export function fetchClubTableDetail(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BossApi/TableDetail`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getClubTableDetail(data))
    })
  }
}

//账单记录
export function fetchClubSettlement(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BossApi/TableSettlementDaily`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getClubSettlement(data))
    })
  }
}

//流水号查询
export function fetchBillRecordDetail(sn) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/RecordDetails/sn/${sn}`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubBillRecordDetail(data))
      return data
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubTableStatus/action.js